import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const ResellerRoutes = defineRoute({
    record: {
        route: {
            path: "/reseller",
            component: () => loadView(import("./ResellerTable.vue")),
        },
    },
    create: {
        route: {
            path: "/reseller/create",
            component: () => loadView(import("./ResellerCreate.vue")),
        },
        debug: true,
    },
    update: {
        route: {
            path: "/reseller/update/:id",
            component: () => loadView(import("./ResellerUpdate.vue")),
        },
        build(id: string) {
            return `/reseller/update/${id}`;
        },
    },
});
